var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getUserPreferencesForCurrentUser_platform } from './accessors/get';
import { updateUserPreferencesForCurrentUser_platform, } from './accessors/update';
const colorThemes = [1, 2];
const defaultColorTheme = 1;
function withDefaults(value) {
    return colorThemes.includes(value) ? value : defaultColorTheme;
}
function cycleThroughThemes(value) {
    const index = colorThemes.indexOf(value);
    const nextIndex = (index + 1) % colorThemes.length;
    return colorThemes[nextIndex];
}
export function getCurrentColorTheme() {
    var _a;
    const result = (_a = getUserPreferencesForCurrentUser_platform()) === null || _a === void 0 ? void 0 : _a.preferedColorTheme;
    return withDefaults(result);
}
export function setCurrentColorTheme(colorTheme) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield updateUserPreferencesForCurrentUser_platform('preferedColorTheme', colorTheme);
        return withDefaults(result);
    });
}
export function toggleCurrentColorTheme() {
    return __awaiter(this, void 0, void 0, function* () {
        const current = getCurrentColorTheme();
        const target = cycleThroughThemes(current);
        const setValue = yield setCurrentColorTheme(target);
        return withDefaults(setValue);
    });
}
